import { render } from "./friends-list.vue?vue&type=template&id=efd53e78"
import script from "./friends-list.vue?vue&type=script&lang=js"
export * from "./friends-list.vue?vue&type=script&lang=js"

import "./friends-list.vue?vue&type=style&index=0&id=efd53e78&lang=css"
script.render = render

export default script